import { Guid } from "@syncfusion/ej2/pdf-export";

export class sortingObj {
    itemperpage: number = 20;
    currentPgNo: number = 1;
    shortcolumn: string = "AgencyName";
    shortType: string = 'asc';
}
export class WhereCondition {
    field: string = "AgencyName";
    value: string = "";
    operator: string = "startswith";
    matchCase: boolean = false;
    orderNo: number = 1;
    predicate: string = "and";
    type: string = "string";
}

export class AgencyListBO {
    id: string = "00000000-0000-0000-0000-000000000000";
    statusLid: string;
    agencyCode: string;
    agencyName: string;
    agencyShortName: string;
    agencyLogo: string;
    email: string;
    phone: string;
    fax: string;
    street: string;
    city: string;
    state: string;
    zipCode: string;
    altStreet: string;
    altCity: string;
    altState: string;
    altZipcode: string;
}

export class agencyStatusList {
    Key: string;
    Value: string;
    //serviceMapList: serviceMappedBO[];
}

export class AgencyStatuslist {
    id: string;
    lovName: string;
}

export class SaveReturnBO {
    agencyId: string;
    errorList: string[];
}
// Notes

export class AgencyNoteBO {
    id: Guid;
    clientId: Guid;
    date: string;
    initial: string;
    notes: string;
    typeListId: Guid ;
    multipletype: [];
}
export class type {
    id: Guid | null;
    typeNumber: any;
    typeName: string;
    typeFor: string;
    agencyId: Guid | null;
}
export class GetAgencyNotes {
    orderColumn: string = "Initial";
    orderType: string = "asc";
    pageitem: number = 10;
    clientId: Guid;
    ages: number;
    client: string;
    currentpageno: number = 1;
    field: string = "Initial";
    value: string = "";
    matchCase: boolean = false;
    operator: string = "contains";
    typeListName: string = "string";
}
export class GetAgencyBO {
    currentpageno: number = 1;
    pageitem: number = 250;
    orderColumn: string = "agencyName";
    orderType: string = "asc";
    type: string = "string";
    field: string = "agencyName";
    operator: string = "contains";
    value: string = "";
    matchCase: boolean = false;
    statusLid: string | null;
}

export class AgencyInfoBO {
    agencyName: string;
    phone: string;
    agencyLogo: string;
    agencyId: string | null;
    agencyCode:string;
}

export class IsViewEdit {
    isView: boolean;
    isEdit: boolean;
    isEditCompany: boolean;
    editCompanyId: string;
    AgencyId: string;
    CompanyData: CompanyList
}

///////////////////////////// ComapnyBO ////////////////////////////////////
export class CompanyReturnBO {
    companyId: string;
    errorList: string[];
}
////////////////////////Company Bo/////////////////////
export class CompanyList {
    id: string = "00000000-0000-0000-0000-000000000000";
    name: string;
    street: string;
    city: string;
    state: string;
    zipCode: string;
    statusName: string;
    adminFullName: string;
    phoneNumber: string;
    fEIN: string;
    fax: string;
    statusLid: string;
    agencyid: string;
    npi:string;
}

export class GetCompanyBase {
    statusLid: string | null;
    locationID: string | null;
    agencyID: string | null;
    currentpageno: number = 1;
    pageitem: number = 50;
    orderColumn: string = "name";
    orderType: string = "asc";
    type: string = "";
    field: string = "name";
    operator: string = "startswith";
    value: string = "";
    matchCase: boolean = false;
}

export class functionpermission {
    agencycreate: boolean = true;
    agencyupdate: boolean = true;
    companycreate: boolean = true;
    companyupdate: boolean = true;
}

export class saveHHAXAggregatorCredential {
    id: string = "00000000-0000-0000-0000-000000000000";
    client_id: string;
    client_secret: string;
    providerTaxId: string;
    companyId: string = "00000000-0000-0000-0000-000000000000";
    companyName: string;
}

export class GetAggregatorBO {
    orderColumn: string = "client_secret";
    orderType: string = "asc";
    pageitem: number = 10;
    currentpageno: number = 1;
    locationId: string = "00000000-0000-0000-0000-000000000000";
    field: string = "client_secret";
    value: string = "";
    matchCase: boolean = false;
    operator: string = "startswith";
    agencyID: string = "00000000-0000-0000-0000-000000000000";
    type: string = "string";
}

export class AggregatorEventBo {
    companyList: any = [];
}